import { ChangeDetectionStrategy, Component, effect, inject, input, model, output } from '@angular/core';
import { TableColumnDirective, TableComponent } from '@shared/table/table.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@shared/shared.module';
import { ArticlePreviewUtils } from '../../util/article-preview.utils';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';
import { parseInt } from 'lodash';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { TooltipDirective } from '@shared/tooltip/tooltip.directive';
import { InputRestrictDirective } from '@shared/directives/input-restrict.directive';

export interface ArticleTableData {
  article: { articleNo: string };
  count?: number;
  image?: string;
}

export interface ArticleTableColumn {
  title: string;
  dataKey: string;
  stretch?: boolean;
}

@Component({
  selector: 'app-article-result-list',
  imports: [
    TableComponent,
    TableColumnDirective,
    TranslateModule,
    SharedModule,
    SvgIconComponent,
    TooltipDirective,
    InputRestrictDirective,
  ],
  templateUrl: './article-result-list.component.html',
  styleUrl: './article-result-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticleResultListComponent<T extends ArticleTableData> {
  private localeResourceManager = inject(LocaleResourceManager);
  public selectedArticle = model<T>();
  public articleAction = output<T>();

  public tableData = input.required<T[]>();
  public tableColumns = input.required<ArticleTableColumn[]>();
  public showArticleImage = input.required<boolean>();
  public showAddButton = input<boolean>(true);

  constructor() {
    effect(() => {
      const tableData = this.tableData();
      const selectedArticle = this.selectedArticle();
      if (tableData && selectedArticle && !tableData.includes(selectedArticle)) {
        this.selectedArticle.set(undefined);
      }
    });
  }

  public executeArticleAction(articleTableData: T) {
    this.articleAction.emit({...articleTableData, count: articleTableData.count || 1});
  }

  public openShopLink(articleNo: string) {
    ArticlePreviewUtils.openShopLink(articleNo, this.localeResourceManager);
  }

  protected readonly parseInt = parseInt;
}
